import request from '../../config/axiosConfig';
import { GET_LIST_STORE_NOTIFICATIONS, REPLAY_STORE_NOTIFICATION } from '../../constants/apiEndPoint';

export const getListStoreNotificationsRequest = async (data) => {
  const result = await request({ url: GET_LIST_STORE_NOTIFICATIONS, method: 'POST', data });
  return result?.data?.data;
};

export const replayStoreNotificationRequest = async (data) => {
  const result = await request({ url: REPLAY_STORE_NOTIFICATION, method: 'POST', data });
  return result?.data;
};
